






















































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class LoginOptions extends Vue {
  /**
     * 选择登录方式
     */
  private selectLoginOption (type: string) {
    this.$emit('selectLoginOption', new CustomEvent('selectLoginOption', {
      detail: type
    }))
  }
}
